import React from 'react';
import { BannerVideoImage, GreenCard } from 'components';

interface PageBannerProps {
  banner: any;
  pageHeading?: string;
  description?: string;
  bannerSummary?: any;
  pageTitle?: string;
  bgColor?: string;
  captionColor?: string;
  powerButtonText?: string;
  onPowerButtonClick?: () => void;
}

const PageBanner: React.FC<PageBannerProps> = ({
  banner,
  pageHeading,
  description,
  bannerSummary,
  pageTitle,
  bgColor = 'orange',
  captionColor = 'lightgreen',
  powerButtonText,
  onPowerButtonClick,
}) => {
  if (!banner) return null;

  return (
    <div className={`bg-${bgColor} right-radius`}>
      <BannerVideoImage banner={banner} />
      <div className={`banner bg-${bgColor}`}>
        <div className="banner-wrapper">
          <div className="banner-content">
            {pageHeading && <h1 className="page-heading">{pageHeading}</h1>}
            {description && (
              <h3 className={`banner-caption font-lg text-${captionColor}`}>
                {description}
              </h3>
            )}
            {bannerSummary && (
              <GreenCard Summary={bannerSummary} pageTitle={pageTitle} />
            )}
            {powerButtonText && onPowerButtonClick && (
              <button
                type="button"
                className="banner-power-btn"
                onClick={onPowerButtonClick}
              >
                {powerButtonText}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export { PageBanner };
